<template>
  <jti-expansion-panel panelName="Vehicle Layout Details">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-container grid-list-lg>
        <v-text-field
          v-model="data.name"
          label="Name"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          v-model="data.floor_count"
          label="Floor"
          :readonly="readonly"
          required
          :rules="[rules.required, rules.number, rules.maxFloor, rules.minFloor]"
        ></v-text-field>
        <v-text-field
          v-model="data.column_count"
          label="Column"
          :readonly="readonly"
          required
          :rules="[rules.required, rules.number]"
        ></v-text-field>
        <v-text-field
          v-model="data.row_count"
          label="Row"
          :readonly="readonly"
          required
          :rules="[rules.required, rules.number]"
        ></v-text-field>
        <v-select
          v-model="data.vehicle_type_id"
          label="Vehicle Type"
          :items="vehicleTypes"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-select>
      </v-container>
    </v-form>
  </jti-expansion-panel>
</template>

<script>
export default {
  props: {
    data: Object,
    vehicleTypes: Array,
    readonly: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        floor_count: this.data.floor_count,
        column_count: this.data.column_count,
        row_count: this.data.row_count,
        vehicle_type_id: this.data.vehicle_type_id
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        number: value => !isNaN(value) || "Must be number.",
        minFloor: value => value >= 1 || "The minimum number is 1.",
        maxFloor: value => value <= 3 || "The maximum number is 3.",
        // minRow: value => value >= 10 || "The minimum row is 10",
        // maxRow: value => value <= 15 || "The maximum row is 15.",
        // minColumn: value => value >= 4 || "The minimum row is 4.",
        // maxColumn: value => value <= 7 || "The maximum row is 7."
      }
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style>
</style>
